import { Fragment, useMemo, useState } from 'react';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import flag from '~/assets/icons/flag.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { RegionSearchInput } from '../../components/RegionSearchInput';
import {
	NumberPlatesRegion,
	setRegion,
	setRegionCode,
	setRegionSelectVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledButtonContent,
	StyledContainer,
	StyledRegionItem,
	StyledRegionList,
	StyledRegionNumber,
	StyledSearchContainer,
} from './RegionSelect.styled';

const RegionSelect = () => {
	const dispatch = useLayoutDispatch();
	const regionState = useLayoutSelector((state) => state.plateBuying.region);
	const regionList = useObservable(rage.vehicleShop.getNumberPlateRegions());
	const indexedRegionList = useMemo(
		() => regionList.map((e, index) => ({ ...e, index })),
		[regionList],
	);
	const [filteredRegionList, setFilteredRegionList] =
		useState(indexedRegionList);

	const handleRegionSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputText = event.currentTarget.value.toLowerCase().trim();
		const filteredList = indexedRegionList.filter((region) => {
			let matched = true;

			const regionArea = region.name.toLowerCase();
			const regionAreaMatch = inputText.match(/\D+/g);
			if (regionAreaMatch !== null) {
				regionAreaMatch.forEach((match) => {
					matched &&= regionArea.includes(match.trim());
				});
			}

			const regionNumber = region.code.toString();
			const regionNumberMatch = inputText.match(/\d+/g);
			if (regionNumberMatch !== null) {
				regionNumberMatch.forEach((match) => {
					matched &&= regionNumber.includes(match.trim());
				});
			}

			return matched;
		});
		setFilteredRegionList(filteredList);
	};

	const handleBack = () => {
		dispatch(setRegionSelectVisible(false));
	};

	const handleRegionSelect = (region: NumberPlatesRegion) => {
		dispatch(setRegion(region));

		const newRegionCode = region.code.toString().padStart(2, '0').slice(-3);
		dispatch(setRegionCode(newRegionCode));
	};

	return (
		<StyledContainer>
			<SectionHeading text={'Выберите регион'} icon={flag} />
			<StyledSearchContainer>
				<RegionSearchInput onChange={handleRegionSearch} />
			</StyledSearchContainer>
			<ScrollContainer height={500} style={{ marginTop: 20 }}>
				<StyledRegionList>
					{filteredRegionList.map((region, index) => (
						<Fragment key={region.code}>
							<StyledRegionItem>
								<StyledRegionNumber>
									<Text>{region.code}</Text>
								</StyledRegionNumber>
								<Text>{region.name}</Text>
								<Button
									color={
										regionState?.code === region.code
											? ButtonColors.Help
											: ButtonColors.Default
									}
									height={ButtonHeight.Height30}
									onClick={() => handleRegionSelect(region)}
								>
									<Text>
										{regionState?.code === region.code ? 'Выбрано' : 'Выбрать'}
									</Text>
								</Button>
							</StyledRegionItem>
							{index !== filteredRegionList.length - 1 && (
								<Divider $direction="H" style={{ opacity: 0.1 }} />
							)}
						</Fragment>
					))}
				</StyledRegionList>
			</ScrollContainer>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height50}
				onClick={handleBack}
				style={{ marginTop: 30 }}
			>
				<StyledButtonContent>
					<img src={arrowLeft} />
					<Text>Вернуться назад</Text>
				</StyledButtonContent>
			</Button>
		</StyledContainer>
	);
};

export { RegionSelect };
